import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import MainFont from 'ui/typography/mainFont';

import { Item, PopupWrapper } from './style';
import { useTranslation } from 'react-i18next';
import { DotsMenu, DotsMenuContainer } from '../../atoms/FormInput/style';
import { ClickOutside } from 'ui/atoms';

const LeadDetailMenu = ({
  isPreference,
  handleSaveCallback,
  handleCallbackDiscard,
  handleDeletePreference
}) => {
  const { t } = useTranslation();
  const [showLeadDetailDropdown, setShowLeadDetailDropdown] = useState(false);

  const handleSave = () => {
    return handleSaveCallback();
  };

  const handleDiscard = () => {
    handleCallbackDiscard();
  };

  return (
    <ClickOutside
      callback={() => {
        if (showLeadDetailDropdown) {
          setShowLeadDetailDropdown(!showLeadDetailDropdown);
        }
      }}
    >
      <DotsMenuContainer>
        <DotsMenu
          onClick={() => {
            setShowLeadDetailDropdown(!showLeadDetailDropdown);
          }}
        />

        {showLeadDetailDropdown && (
          <PopupWrapper>
            <Item onClick={handleSave}>
              <MainFont
                type="accountPopupText"
                configuration={{ fontWeight: 'medium' }}
              >
                {t('save')}
              </MainFont>
            </Item>
            <Item onClick={handleDiscard}>
              <MainFont
                type="accountPopupText"
                configuration={{ fontWeight: 'medium', textAlign: 'left' }}
              >
                {t('cancel')}
              </MainFont>
            </Item>
            {isPreference && (
              <Item onClick={handleDeletePreference}>
                <MainFont
                  type="accountPopupText"
                  configuration={{ fontWeight: 'medium' }}
                >
                  {t('delete_preference')}
                </MainFont>
              </Item>
            )}
          </PopupWrapper>
        )}
      </DotsMenuContainer>
    </ClickOutside>
  );
};

LeadDetailMenu.propTypes = {
  handleSaveCallback: PropTypes.func,
  isPreference: PropTypes.bool,
  handleCallbackDiscard: PropTypes.func,
  handleDeletePreference: PropTypes.func
};

export default connect(null, null)(LeadDetailMenu);
